export const singleCylinderOptions = [
    { val: "center", labelKey: "center" },
    { val: "top", labelKey: "outerTop" },
    { val: "bottom", labelKey: "innerBottom" },
] as const;

export const multiCylinderOptions = [
    { val: "closest", labelKey: "closest" },
    { val: "furthest", labelKey: "furthest" },
] as const;

export const cylinderOptions = [...singleCylinderOptions, ...multiCylinderOptions];

export const snapKinds = [
    { val: "all", labelKey: "all" },
    { val: "point", labelKey: "point" },
    { val: "curve", labelKey: "curve" },
    { val: "surface", labelKey: "surface" },
    { val: "clippingOutline", labelKey: "outline" },
] as const;

export type SnapKind = (typeof snapKinds)[number]["val"];
